import React from 'react';
import styled from 'styled-components';
import { Business } from '../../../types/business.type';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from '../../common/Table';
import Button from '../../common/Button';
import Business_default_logo from '../../../assets/images/icon_business.svg';
import { useCall } from '../../../customer-call-sdk';

const StyleBusinessList = styled.div`
    .imgStyle {
        max-height: 50px;
        max-width: 50px;
    }
    .directory-table-body {
        th {
            min-height: 70px;
            width: auto;
        }
    }
`;

interface BusinessListComponentPropsType {
    businessList: Business[] | null;
    totalCount: number;
    limit: number;
    page: number;
    handleChangePage: (event: any, newPage: number) => void;
    handleChangeRowsPerPage: (event: any) => void;
}
const BusinessListComponent = ({
    businessList,
    page,
    limit,
    totalCount,
    handleChangePage,
    handleChangeRowsPerPage,
}: BusinessListComponentPropsType) => {
    const call = useCall();

    const handleCallClick = (number: string) => {
        call.makeCall({ toPhoneNumber: number });
    };

    return (
        <StyleBusinessList>
            <TableContainer>
                <Table aria-label="simple table" size="medium">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left" />
                            <TableCell align="left">Name</TableCell>
                            <TableCell align="left">Description</TableCell>
                            <TableCell align="left" />
                        </TableRow>
                    </TableHead>
                    <TableBody className="directory-table-body">
                        {businessList?.map((business: Business, index: number) => {
                            return (
                                <TableRow key={`DirectoryRow_${index}`}>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                        className="whitespace-no-wrap"
                                    >
                                        {business.photoURL ? (
                                            <img
                                                className="imgStyle"
                                                src={business.photoURL}
                                                alt="logo"
                                            />
                                        ) : (
                                            <img
                                                className="imgStyle"
                                                src={Business_default_logo}
                                                alt="logo"
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                        className="whitespace-no-wrap"
                                    >
                                        <span>{business.businessName}</span>
                                    </TableCell>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                        className="whitespace-no-wrap"
                                    >
                                        <span>{business.description}</span>
                                    </TableCell>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                        className="whitespace-no-wrap"
                                    >
                                        <Button
                                            color="primary"
                                            type="button"
                                            onClick={() => handleCallClick(business.number)}
                                        >
                                            CALL
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={totalCount}
                rowsPerPage={limit}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </StyleBusinessList>
    );
};

export default BusinessListComponent;
